const PIXEL_ID = '1320212723322841'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

function loadPixelScript() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  const n: any = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Safely insert into document - prefer head, fallback to first script, fallback to body
  const head = document.head || document.getElementsByTagName('head')[0]
  if (head) {
    head.appendChild(t)
  } else {
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(t, firstScript)
    } else {
      document.body.appendChild(t)
    }
  }
}

export function initPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return
  try {
    loadPixelScript()
    window.fbq && window.fbq('init', PIXEL_ID)
    initialized = true
  } catch (e) {
    console.warn('Meta Pixel init failed', e)
  }
}

export function trackPageView() {
  initPixel()
  try {
    window.fbq && window.fbq('track', 'PageView')
  } catch (e) {
    console.warn('Meta Pixel PageView failed', e)
  }
}

export function trackAddToCart() {
  initPixel()
  try {
    window.fbq &&
      window.fbq('track', 'AddToCart', {
        content_name: 'Vuelve a Sentirte Tú: Menopause Reset',
        content_ids: ['menopause-reset'],
        content_type: 'product',
        value: 14.0,
        currency: 'USD',
      })
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed', e)
  }
}
